import { unitMapping } from 'lib/style';
import type { Color } from 'style/types';

type Props = {
  color?: Color;
  size?: keyof typeof unitMapping;
  title?: string;
};

export const RotateLeft = ({ color, size = 2, title }: Props) => {
  return (
    <svg
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: unitMapping[size], height: unitMapping[size] }}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M16 7.9989C16 12.2748 12.5172 15.723 8.27586 15.723C6.58621 15.723 4.96552 15.2058 3.62069 14.2058C3.13793 13.8265 3.03448 13.1368 3.41379 12.6541C3.7931 12.1713 4.48276 12.0679 4.96552 12.4127C5.93103 13.1368 7.06897 13.5161 8.27586 13.5161C11.3103 13.5161 13.7931 11.0679 13.7931 7.9989C13.7931 4.96442 11.3103 2.51614 8.27586 2.51614C6.96552 2.51614 5.75862 2.96441 4.75862 3.75752L6.34483 5.30924C6.93103 5.89545 6.48276 6.92993 5.65517 6.92993H0.655172C0.275862 6.92993 0 6.61959 0 6.24028V1.24028C0 0.378208 1 -0.0355852 1.58621 0.550622L3.2069 2.20579C4.58621 0.998898 6.37931 0.309242 8.27586 0.309242C12.5172 0.309242 16 3.75752 16 7.9989Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
};
